import styled from 'styled-components';

export const InlineWrapper = styled.div`
  color: #de2f1b;
  font-size: 16px;
  font-weight: 500;
`;

export const OptionButton = styled.button`
  color: inherit;
  font-size: inherit;
  font-weight: inherit;

  padding: 3px 4px;
  border: none;
  background: none;
  cursor: pointer;

  &:first-child {
    padding-left: 8px;
  }
`;
